import React from "react";

const CreateSinglePage = () => {
  return (
    <div>
      <h1>This is a single page create dashboard</h1>
    </div>
  );
};

export default CreateSinglePage;
